//
// Generated class DBDocument
//

/// <reference path="DBDocument_ManagedObject.ts" />

enum DBDocumentStatus
{
    none = 0,
    pending = 1,
    processed = 2,
    unprocessed = 3
}

enum DBDocumentOCRStatus {
    none = 0,
    scanning = 1,
    processed = 2,
    extracted = 3,
    failed = 4
}


class DBDocument extends DBDocument_ManagedObject
{

}
